import { Component, OnInit, ViewChild } from '@angular/core';
import { CbtService } from '../services/cbt.service';
import { Router } from '@angular/router';
import { CompanyDetailsService } from '../services/company-details.service';
import { UserService } from '../services/user.service';
import { LogService } from '../services/log.service';
import { Location } from '@angular/common';
import * as faceapi from 'face-api.js';
@Component({
  selector: 'app-exam-details',
  templateUrl: './exam-details.component.html',
  styleUrls: ['./exam-details.component.css']
})
export class ExamDetailsComponent implements OnInit {
  public examToBeTaken;
  p_system = localStorage['p_system'];
  public examDetails: any = {
    exam_title: null,
    description: null,
    instruction: null,
    duration: null,
    time_left: null,
    exam_id: null,
    exam_mode: null,
    invigilator_code: null,
  };
  public duration;
  public timeLeft;
  public company;
  public student;
  public inv_code = "";
  public verified = true;
  public invCodeMsg = "";
  public cameraMsg = "";
  public exam_mode;
  public camera_check;
  public offenceFull = false;

  currentTime = this.getDateObj();
  timeInterval: NodeJS.Timeout;

  @ViewChild('video') video;
  @ViewChild('image') image;

  public faceDetected = false;
  public interval: any;
  constructor(private _cbtService: CbtService, private router: Router,
    private _companyDetailsService: CompanyDetailsService,
    private _userService: UserService, public log: LogService,
    private location: Location) {
    this.examToBeTaken = this._cbtService.examTobeTaken;
    if (!this.examToBeTaken) {
      this.router.navigate(['/home/dashboard']);
      return;
    }
    this._cbtService.examInitialSummary({ request: 'get_exam_summary', exam_id: this.examToBeTaken.exam_id }).subscribe(data => {
      this.examDetails = data;
      this.duration = Math.floor(this.examDetails.duration / 60);
      this.timeLeft = Math.floor(this.examDetails.time_left / 60);
      this.exam_mode = this.examDetails.exam_mode;
      this.camera_check = this.examDetails.camera_sound_check;
      this._cbtService.examModeDetails.next({ exam_mode: this.examDetails.exam_mode, camera_check: this.examDetails.camera_sound_check, screen_check: this.examDetails.screen_tab_check, offence_limit: this.examDetails.offence_limit });
      if (data.offence_count >= data.offence_limit && data.block_reentry_onlimit == 1) {
        this.verified = false;
        this.offenceFull = true;
      }
    })
  }

  ngOnInit() {
    if (!this.examToBeTaken) return;

    this.log
      .addLog({
        action: "Access",
        component: "Exam Details",
        details: `Accessed Exam Details`,
      }).subscribe(data => { });
    this._companyDetailsService.getDetails().subscribe(data => {
      this.company = {
        logo: data.logo,
        name: data.name,
        subdomain: data.adm_initial
      }
    })
    this._userService.getUserData().subscribe(data => {
      this.student = {
        name: data.lastname + " " + data.firstname,
        passport: data.passport,
        matric_no: data.matric_no,
        student_id: data.student_id,
      };
    })
    this._cbtService.examInitialSummary({ request: 'get_exam_summary', exam_id: this.examToBeTaken.exam_id }).subscribe(data => {
      if (data.exam_mode == 1 && data.camera_sound_check == 1) {
        Promise.all([
          faceapi.nets.tinyFaceDetector.loadFromUri('assets/models'),
          faceapi.nets.faceLandmark68Net.loadFromUri('assets/models'),
          faceapi.nets.faceRecognitionNet.loadFromUri('assets/models'),
          faceapi.nets.faceExpressionNet.loadFromUri('assets/models'),
          faceapi.nets.ssdMobilenetv1.loadFromUri('assets/models')
        ]).then(() => this.startVideo());
        this.verified = false;
        // this.verified = true;
        this.cameraMsg = "Trying to pick your face....."
      } else if (data.exam_mode == 0 && data.invigilator_code) {
        this.verified = false;
      }
    })
    this.timeInterval = setInterval(() => {
      this.currentTime = this.getDateObj();
    }, 1000);


  }

  ngOnDestroy() {
    clearInterval(this.timeInterval)
  }

  goBack() {
    this.location.back();
  }

  getDateObj() {
    const dateObj = new Date();
    return {
      time: dateObj.toLocaleTimeString(),
      year: dateObj.getFullYear(),
      date: dateObj.toLocaleDateString('en-US', { day: '2-digit', month: 'long', year: 'numeric' }),
    };
  }


  startExam() {
    clearInterval(this.interval);
    // if (this.faceDetected) {
    // }
    this.router.navigate(['/cbt/exam']);
  }

  checkInvigilatorCode() {
    this.invCodeMsg = "Code must be 5 characters.";
    if (this.inv_code.length == 5) {
      this.invCodeMsg = "Verifying code.....";
      let obj = { invigilator_code: this.inv_code, exam_id: this.examDetails.exam_id };
      this._cbtService.checkInvigilatorCode(obj).subscribe(data => {
        if (data.success == true) {
          this.verified = true;
          this.invCodeMsg = "Verified! Kindly proceed";
        } else {
          this.verified = false;
          this.invCodeMsg = data.msg;
        }
      })
    } else {
      this.verified = false;
      this.invCodeMsg = "Code must be 5 characters."
    }
    // console.log(this.inv_code);
  }

  startVideo() { //START VIDEO
    let video = this.video.nativeElement;
    if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
      navigator.mediaDevices.getUserMedia({ video: true }).then((stream) => {
        video.srcObject = stream;
        video.addEventListener('play', async () => {
          const canvas = await faceapi.createCanvasFromMedia(video);
          document.body.append(canvas);
          const displaySize = { width: video.width, height: video.height }
          faceapi.matchDimensions(canvas, displaySize);

          this.interval = setInterval(async () => {
            const detections = await faceapi.detectAllFaces(video, new faceapi.TinyFaceDetectorOptions()).withFaceLandmarks().withFaceExpressions()
            // console.log('detections: ', detections);
            if (detections.length > 0 && !this.faceDetected) {
              this.faceDetected = true;
              this.cameraMsg = "Face Recognised. Kindly Proceed!"
              this.verified = true;
              localStorage.setItem('detected', "true");

              const canvas = document.createElement('canvas');
              canvas.width = video.videoWidth;
              canvas.height = video.videoHeight;
              canvas.classList.add("hidden")
              canvas.getContext('2d').drawImage(video, 0, 0);

              const img = document.createElement("img");
              img.src = canvas.toDataURL('image/webp');
              // console.log(img.src, "image");
              let form = new FormData();
              form.append("img", canvas.toDataURL('image/webp'));
              this._cbtService.examStudentImage.next(img.src);
              // this.auth.saveImage(form).subscribe(data => {

              // })
            }

            const resizedDetections = faceapi.resizeResults(detections, displaySize)
            canvas.getContext('2d').clearRect(0, 0, canvas.width, canvas.height)

            //THIS PART DRAWS LANDMARKS AND EXPRESSION ON FACES IN THE VIDEO
            // faceapi.draw.drawDetections(canvas, resizedDetections)
            // faceapi.draw.drawFaceLandmarks(canvas, resizedDetections)
            // faceapi.draw.drawFaceExpressions(canvas, resizedDetections)
          }, 2000)
        })

      });

    }

  }

}
